module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(typeof _vm.reminder !== 'undefined') ? _c('span', [(!_vm.present) ? _c('span', [_c('el-popover', {
    attrs: {
      "placement": "top",
      "width": "200",
      "trigger": "hover",
      "content": _vm.reminder.description
    }
  }, [_c('span', {
    directives: [{
      name: "edit",
      rawName: "v-edit:reminder",
      value: (_vm.reminder),
      expression: "reminder",
      arg: "reminder"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "fa fa-circle",
    style: ({
      color: _vm.reminder.category.color
    })
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.reminder.date.date, 'DD/MM/YYYY')))]), _vm._v(" : " + _vm._s(_vm.reminder.category.name) + "\n        ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.present === 'description') ? _c('span', [(_vm.reminder.description) ? _c('span', [_vm._v(_vm._s(_vm.reminder.description))]) : _vm._e()]) : _vm._e()]) : _c('span', [_c('pulse-loader', {
    attrs: {
      "color": "#cccccc",
      "size": "8px"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22681d6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Entities/Reminder.vue
// module id = 676
// module chunks = 1